module.exports = __webpack_public_path__ + "img/jar.f3a71a9e.svg";